import { render, staticRenderFns } from "./UpdateReference.vue?vue&type=template&id=ef8ab052&"
import script from "./UpdateReference.vue?vue&type=script&lang=ts&"
export * from "./UpdateReference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports